import type { SVGAttributes } from 'react';

export function FilterCategoryIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props} viewBox="0 0 24 24">
			<rect width="24" height="24" fill="currentColor" fillOpacity=".1" rx="4" />
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12.414 17.873c-.227.08-.6.08-.827 0-1.934-.66-6.253-3.413-6.253-8.08 0-2.06 1.66-3.726 3.706-3.726 1.214 0 2.287.586 2.96 1.493a3.69 3.69 0 0 1 2.96-1.493 3.715 3.715 0 0 1 3.707 3.726c0 4.667-4.32 7.42-6.254 8.08"
			/>
		</svg>
	);
}
